

import { Card, Col, Divider, Form, Input, Row, Space, Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast, loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from "../../services/repo/useOrgRepo";
import useDeptRepo from "../../services/repo/useDepartmentRepo";
import useDivRepo from "../../services/repo/useDivisionRepo";
import useWBSRepo from "../../services/repo/useWBSInitRepo";
import usePositionRepo from "../../services/repo/usePositionRepo";
import useParamRepo from "../../services/repo/useParamRepo";
import WbsFilterForm from './WbsFilterForm'; // sesuaikan path jika berbeda


export default function Wbs() {

    useTopbarTitleHooks("WORK BREAKDOWN STRUCTURE");
    const { isLoading: isLoadingWbsList, getWBSList } = useWBSRepo(false)
    const { isLoading: isLoadingDeptList, getDepartmentList, isLoadingDelete, deleteDepartment } = useDeptRepo(false);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    const { isLoading: isLoadingDivList, getDivisionList } = useDivRepo(false)
    const { isLoading: isLoadingPosList, getPositionList } = usePositionRepo(false);
    const { isLoading: isLoadingWfList, getParamByCategory } = useParamRepo(false);


    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)
  


    // const { isHasPrivilege } = useAccessPermissionHook()
    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        orgId: null,
        divId: null,
        deptId: null,
        posId: null,
        wfId: null
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "divName",
        isAscending: true
    });


    const onSearch = (value) => {
        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters
            }
        }))
    };

    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                orgId: null,
                orgName: "",
                status: "true",
            },
        }

        const res = await getOrgList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {

            const options = res.data.content.map(item => ({
                label: item?.orgName,
                value: item?.orgId,
            }));

            setOrgOptions(options);

            if (options.length === 1) {
                const onlyOption = options[0];

                form.setFieldsValue({ orgId: onlyOption }); // isinya harus { label, value }
                setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

                setTableParams((prev) => ({
                    ...prev,
                    filter: {
                        ...prev.filter,
                        orgId: onlyOption.value
                    }
                }));
                fetchDataDivision(onlyOption.value);
            }
        }
    }

    const [divOptions, setDivOptions] = useState([])
    const fetchDataDivision = async (orgId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                divCode: "",
                divName: "",
                orgId: orgId,
                divId: null,
                status: "true",
            },
            orderBy: "divCode",
            isAscending: true
        }
        setDivOptions([])

        const res = await getDivisionList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setDivOptions(() => {
                return res?.data?.content.map(item => {
                    return {
                        value: item?.divId,
                        label: item?.divName
                    }
                })
            })
        }
    }

    const [deptOptions, setDeptOptions] = useState([])
    const fetchDataDepartment = async (divId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                deptId: null,
                deptName: "",
                divId: divId,
                status: "true"
            },
            orderBy: "deptName",
            isAscending: true
        }

        setDeptOptions([])
        const res = await getDepartmentList(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            setDeptOptions(() =>
                res?.data?.content.map((item) => ({
                    label: item?.deptName,
                    value: item?.deptId
                }))
            )
        }
    }

    const [posOptions, setPosOptions] = useState([])
    const fetchDataPosition = async (deptId) => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            filter: {
                posId: null,
                posName: "",
                deptId: deptId,
                status: "true"
            },
            orderBy: "posName",
            isAscending: true
        }

        setPosOptions([])
        const res = await getPositionList(payload)  // pastikan fungsi ini dari `usePositionRepo`
        if (res?.detail === 'OK' && res?.status === 200) {
            setPosOptions(() =>
                res?.data?.content.map(item => ({
                    label: item?.posName,
                    value: item?.posId
                }))
            )
        }
    }

    const [wfOptions, setWfOptions] = useState([])
    const fetchDataWorkflow = async () => {
        const payload = {
            paramCategory: "wbs_wf"
        }

        const res = await getParamByCategory(payload)
        if (res?.detail === 'OK' && res?.status === 200) {
            setWfOptions(() =>
                res?.data?.map(item => ({
                    label: item?.paramValue,
                    value: item?.paramId
                }))
            )
        }
    }

    const fetchData = async () => {
        const payload = {
            ...tableParams
        }
        const res = await getWBSList(payload)

        if (res?.detail == 'OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };

    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.workBreakdownStructure.create);
    }

    const handleEdit = async (data) => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.workBreakdownStructure.edit(data?.wbsId))
    }

    const handleDelete = async (record) => {
        const key = 'deleteWbs';
        try {

            // debugger

            // loadingToastId(Constant.message.loading, key)

            // const response = await deleteOrg({ orgId: record.orgId });

            // if (response?.status === 200 && response?.detail === 'OK') {
            //     successToast(Constant.message.deleteDataSuccess);
            //     fetchData();
            // } else {
            //     errorToast(Constant.message.deleteDataFail);
            // }
        } catch (error) {
            console.error('Error:', error);
            errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key);
        }
    };

    const fetchCheckPrivilege = async () => {
        setShowButtonAdd('Add')
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        fetchData();
        dismissToast(PRIVILEGE_ID.AddEditOrg);
    }

    useEffect(() => {
        fetchCheckPrivilege()
        fetchDataOrg()
        fetchDataWorkflow()
    }, [])

    useEffect(() => {
        if (isLoadedPrivilege) {
            fetchData();
        }
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);

    const filterUI = () => (
        <WbsFilterForm
            form={form}
            filters={filters}
            setFilters={setFilters}
            orgOptions={orgOptions}
            divOptions={divOptions}
            deptOptions={deptOptions} // ✅ baru
            setDivOptions={setDivOptions}
            setDeptOptions={setDeptOptions} // ✅ baru
            isLoadingOrgList={isLoadingOrgList}
            isLoadingDivList={isLoadingDivList}
            isLoadingDeptList={isLoadingDeptList} // ✅ baru
            fetchDataDivision={fetchDataDivision}
            fetchDataDepartment={fetchDataDepartment} // ✅ baru
            posOptions={posOptions}
            setPosOptions={setPosOptions}
            isLoadingPosList={isLoadingPosList}
            fetchDataPosition={fetchDataPosition}
            wfOptions={wfOptions}
            setWfOptions={setWfOptions}
            isLoadingWfList={isLoadingWfList}
            fetchDataWorkflow={fetchDataWorkflow}
        />
    )


    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "60px",
            render: (_, record) => {
                //const buttons = showButtonAdd ? ['edit', 'delete'] : ['delete']
                const buttons = []
                if (record.isInitEditable && showButtonAdd) buttons.push('edit')
                buttons.push('delete')

                return (
                    <ButtonAction
                        buttons={buttons}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        data={record}
                        loadingDelete={isLoadingDelete}
                    />
                )
            }
        },
        {
            title: 'WBS NO',
            dataIndex: 'wbsNo',
            width: "150px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Division',
            dataIndex: 'divName',
            width: "150px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Department',
            dataIndex: 'deptName',
            width: "150px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Jabatan',
            dataIndex: 'posName',
            width: "150px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Status',
            dataIndex: 'wfName',
            width: "100px",
            render: (data) => <CellTable data={data} />
        }

    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"wbsId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingWbsList}
                                    onChange={handleTableChange}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }



            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
